import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { GlobalConstants } from "../../common/global";
import { Services } from "src/app/services/api.service"
import { environment } from './../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { PagesService } from 'src/app/services/pages.service';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { CommonModule } from '@angular/common';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { ForgottenPasswordComponent } from 'src/app/components/forgotten-password/forgotten-password.component';
import { RegistrationComponent } from 'src/app/components/registration/registration.component';
import { NavigationCartComponent } from "../../components/navigation-cart/navigation-cart.component";
import { LanguageService } from 'src/app/services/language.service';
import { Language } from 'src/app/common/languages.config';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { AppConfig } from 'src/app/common/app-config/app-config.interface';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';
import { BuyMembershipComponent } from 'src/app/pages/membership/buy-membership/buy-membership.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { concat, filter, skip } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl:  `./${environment.pageFolder}/navigation-bar.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/navigation-bar.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [RouterModule, TranslateModule, CommonModule, LoginPopupComponent, ForgottenPasswordComponent, RegistrationComponent, NavigationCartComponent, BuyMembershipComponent]
})

export class NavigationBarComponent implements OnInit {
  isLogged: boolean = false;
  homepageLink = environment.url;
  isNavOpen: boolean = false;
  username: string = "";
  firstName: string = "";
  redirectUrl = environment.redirectUrl;
  envPage = environment.page;
  activePage: any;
  gdprConsent!: boolean;
  hideNav: boolean = false;
  appConfig: AppConfig;
  page = environment.page;
  isLoginModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Login) ?? false);
  isMembershipModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Membership) ?? false);
  isForgottenPassModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.ForgottenPassword) ?? false);
  isRegistrationModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Registration) ?? false);
  userHasMembership: boolean = true;
  hasConnectedGroupTicket?: boolean;
  hasGamesForDelegation?: boolean;
  transferTicketLoading: boolean = true;
  isMembershipRenewable: boolean = false;
  private readonly destroyRef = inject(DestroyRef);

  public readonly languageEnum = Language;
  public readonly modalNamesEnum = ModalNames;

  readonly becomingMemberDisabled: boolean = environment.becomingMemberDisabled;

  constructor(
    public Services: Services,
    private readonly userProfileService: GetUserProfileService,
    public languageService: LanguageService,
    private router: Router,
    private pagesService: PagesService,
    private appConfigService: AppConfigService,
    public modalService: ModalService,
    private profileService: ProfileService
  ) {
    this.appConfig = this.appConfigService.getConfig();
  }

  ngOnInit(): void {
    let currentURL = window.location.href;
    this.activePage = currentURL.substring(currentURL.lastIndexOf('/') + 1);
    this.isLogged = GlobalConstants.isAuth;

    if (!this.isLogged) return;

    concat(
      this.userProfileService.getUserProfile(),
      this.userProfileService.userProfile$.pipe(skip(1))
    )
    .pipe(
      filter(userProfile => userProfile != null),
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe({
      next: (userProfile) => {
        if (currentURL.includes('privacy-policy') && !userProfile.gdprCheck) {
          this.hideNav = true;
        }

        if (this.isLogged) {
          this.firstName = userProfile.firstName;
          this.username = `${userProfile.firstName} ${userProfile.lastName}`;
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.Services.logout();
        }
      }
    });

    if(environment.configId === "4" && this.isLogged) {
      this.transferTicketLoading = true;

      this.profileService.getMemberships(true).subscribe({
        next: (data) => {
          const response: any = data;
          this.userHasMembership = (response.data.own || response.data.others.length > 0) ? true : false;

          if(this.userHasMembership && !response.data.own.isActive && !response.data?.own?.isRenewable) {
            this.userHasMembership = false;
          } else {
            this.isMembershipRenewable = response.data?.own?.isRenewable;
          }


          if(!this.userHasMembership && sessionStorage.getItem("openModal") === "membership") {
            if (!this.becomingMemberDisabled) {
              this.modalService.openModal(this.modalNamesEnum.Membership);
              sessionStorage.removeItem("openModal");
            }
          } else if(sessionStorage.getItem("openModal") === "membership") {
            sessionStorage.removeItem("openModal");
            this.router.navigate(["/membership-profile"]);
          }
        }
      });

      this.profileService.getSubsribersTickets(true).subscribe({
        next: (data) => {
          const response: any = data;
          const subscribers = response.data.others;

          if(subscribers.length === 0) {
            this.hasConnectedGroupTicket = false;
          } else {
            this.hasConnectedGroupTicket = true;
            this.hasGamesForDelegation = subscribers.some((subscriber: any) => subscriber.ticketDelegation);
          }
          this.transferTicketLoading = false;
        },
        error: () => {
          this.hasConnectedGroupTicket = false;
          this.transferTicketLoading = false;
        },
      });
    }
  }

  changeActivePage(activePage: string) {
    this.activePage = activePage;
    this.pagesService.changePage(activePage);
  }

  toggleNav() {
    this.isNavOpen = !this.isNavOpen;
  }

  openMembershipPage() {
    if(!this.isLogged) {
      this.modalService.openModal(ModalNames.Login);
    } else {
      document.location = `${environment.redirectUrl}/membership`;
    }
  }

  changeUrl(url: string) {
    if(!this.isLogged) {
      this.modalService.openModal(ModalNames.Login);
      sessionStorage.setItem("openPage", url);
    } else {
      this.router.navigate([url]);
    }
  }

  changeRoute(url: string) {
    this.isNavOpen = this.isNavOpen ? false : true;
    this.router.navigate([url]);
  }

  openMembershipModal() {
    if (!this.becomingMemberDisabled) {
      if(this.isLogged) {
        this.modalService.openModal(this.modalNamesEnum.Membership);
      } else {
        this.modalService.openModal(this.modalNamesEnum.Login);
        sessionStorage.setItem("openModal", "membership");
      }
    }

    this.isNavOpen = false;
  }
}
